<div class="w-full bg-white border-box radius-10" style="border-radius: 10px;" id="election-information">
  <div class="p-20" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center mb-5">
      <img src="assets/square-icon.svg" alt="">
      <div>
        <p class="no-margin light-blue bold">Identification de l'entreprise</p>
        <p class="no-margin dark-gray text-sm">Informations légales de votre société</p>
      </div>
    </div>
  </div>


  <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px;" id="information-grid" class="p-20">
    <div>
      <p class="dark-blue no-margin">Raison sociale <span class="red">*</span></p>
      <input [(ngModel)]="venue.legalName" (ngModelChange)="onVenueChange()" type="text" name="raison_sociale"
        id="raison_sociale" class="w-full text-md dark-blue pap-input" value="{{venue.legalName}}">
    </div>

    <div>
      <p class="dark-blue no-margin">Forme juridique <span class="red">*</span></p>
      <input [(ngModel)]="venue.legalForm" (ngModelChange)="onVenueChange()" type="text" name="forme_juridique"
        id="forme_juridique" class="w-full text-md dark-blue pap-input" value="{{venue.legalForm}}">
    </div>

    <div>
      <p class="dark-blue no-margin">Capital <span class="red">*</span></p>
      <input [(ngModel)]="venue.capital" (ngModelChange)="onVenueChange()" (keypress)="onlyNumbers($event)" type="text"
        name="capital" id="capital" pattern="[0-9]*" inputmode="numeric" class="w-full text-md dark-blue pap-input"
        value="{{venue.capital}}">
    </div>

    <div>
      <p class="dark-blue no-margin">Ville RCS <span class="red">*</span></p>
      <input [(ngModel)]="venue.rcs" (ngModelChange)="onVenueChange()" type="text" name="rcs" id="rcs"
        class="w-full text-md dark-blue pap-input" value="{{venue.rcs}}">
    </div>

    <div>
      <p class="dark-blue no-margin">SIRET <span class="red">*</span></p>
      <input [(ngModel)]="venue.siret" (ngModelChange)="onVenueChange()" (keypress)="onlyNumbers($event)" type="text"
        name="siret" id="siret" maxlength="14" pattern="[0-9]*" inputmode="numeric"
        class="w-full text-md dark-blue pap-input" value="{{venue.siret}}">
    </div>

    <div></div>

    <div style="grid-column: 1 / -1;">
      <p class="dark-blue no-margin">Adresse <span class="red">*</span></p>
      <input [(ngModel)]="venue.address" (ngModelChange)="onVenueChange()" type="text" name="address" id="address"
        class="w-full text-md dark-blue pap-input" value="{{venue.address}}">
    </div>

    <div>
      <p class="dark-blue no-margin">Code Postal <span class="red">*</span></p>
      <input [(ngModel)]="venue.zipcode" (ngModelChange)="onVenueChange()" type="text" name="postal_code" id="zip"
        class="w-full text-md dark-blue pap-input" value="{{venue.zipcode}}">
    </div>

    <div>
      <p class="dark-blue no-margin">Ville / Commune <span class="red">*</span></p>
      <input [(ngModel)]="venue.city" (ngModelChange)="onVenueChange()" type="text" name="city" id="city"
        class="w-full text-md dark-blue pap-input" value="{{venue.city}}">
    </div>

  </div>
</div>